// src/website/components/EventAgenda.jsx
import React from 'react';

const EventAgenda = ({ programs }) => {
  if (!programs || programs.length === 0) {
    return null;
  }

  return (
    <section className="event-agenda" id="agenda">
      <div className="container">
        <h2 className="section-title">Event Agenda</h2>
        
        <div className="agenda-list">
          {programs.map((program, index) => (
            <div key={program._id || index} className="agenda-item">
              <div className="agenda-time">
                <span className="time-start">{program.startTime}</span>
                <span className="time-end">{program.endTime}</span>
              </div>
              
              <div className="agenda-content">
                <h3 className="agenda-title">{program.title}</h3>
                <p className="agenda-description">{program.description}</p>
                
                <div className="agenda-meta">
                  {program.venueName && (
                    <span className="agenda-venue">📍 {program.venueName}</span>
                  )}
                  {program.category && (
                    <span className="agenda-category">{program.category}</span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventAgenda;